var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00019 0.833374C5.14672 0.833374 2.83352 3.14657 2.83352 6.00004V6.46944C2.83352 6.93406 2.696 7.38828 2.43827 7.77486L1.67254 8.92346C0.783808 10.2566 1.46228 12.0686 3.00801 12.4901C3.51175 12.6275 4.01974 12.7437 4.53068 12.8388L4.53195 12.8422C5.04461 14.2101 6.41482 15.1667 8.00015 15.1667C9.58548 15.1667 10.9557 14.2101 11.4683 12.8422L11.4696 12.8388C11.9806 12.7437 12.4886 12.6275 12.9924 12.4901C14.5381 12.0686 15.2166 10.2566 14.3278 8.92346L13.5621 7.77486C13.3044 7.38828 13.1669 6.93406 13.1669 6.46944V6.00004C13.1669 3.14657 10.8537 0.833374 8.00019 0.833374ZM10.2511 13.0247C8.75583 13.2033 7.24446 13.2033 5.74916 13.0247C6.22313 13.7057 7.04751 14.1667 8.00015 14.1667C8.95278 14.1667 9.77716 13.7057 10.2511 13.0247ZM3.83352 6.00004C3.83352 3.69885 5.699 1.83337 8.00019 1.83337C10.3014 1.83337 12.1669 3.69885 12.1669 6.00004V6.46944C12.1669 7.13148 12.3628 7.77871 12.7301 8.32956L13.4958 9.47816C14.0059 10.2433 13.6165 11.2834 12.7293 11.5254C9.63309 12.3698 6.36729 12.3698 3.27112 11.5254C2.3839 11.2834 1.99447 10.2433 2.50459 9.47816L3.27032 8.32956C3.63756 7.77871 3.83352 7.13148 3.83352 6.46944V6.00004Z",
    fill: "#1A1B1D",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsicon);
export default __webpack_public_path__ + "static/media/notificationsicon.5c8c9eb1bfc311dcbda532d4eb57a51c.svg";
export { ForwardRef as ReactComponent };